import { render, staticRenderFns } from "./doubtfulDebtors.vue?vue&type=template&id=709e030e&scoped=true&"
import script from "./doubtfulDebtors.vue?vue&type=script&lang=js&"
export * from "./doubtfulDebtors.vue?vue&type=script&lang=js&"
import style0 from "./doubtfulDebtors.vue?vue&type=style&index=0&id=709e030e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e030e",
  null
  
)

export default component.exports